import productIconSvg from '../../../../resources/branding/icon.svg';
import productIconInvertedSvg from '../../../../resources/branding/icon-inverted.svg';
import productIconSvgMarkupSource from '../../../../resources/branding/icon.svg?raw';

export const productIconTitle = 'Tov+ product icon';
export const productIconMimeType = 'image/svg+xml';
export const productIconSvgMarkup = productIconSvgMarkupSource;

function resolveProductIconUrl(asset: string | { src: string }): string {
  return typeof asset === 'string' ? asset : asset.src;
}

export const productIconDataUrl = resolveProductIconUrl(productIconSvg);
export const productIconInvertedDataUrl = resolveProductIconUrl(
  productIconInvertedSvg,
);

interface LinkLike {
  parentNode?: unknown;
  setAttribute(name: string, value: string): void;
}

interface HeadLike {
  append(...nodes: unknown[]): void;
  querySelector(selector: string): LinkLike | null;
}

interface DocumentLike {
  head: HeadLike;
  createElement(tagName: string): LinkLike;
}

export function installProductIconLinks(document: DocumentLike): void {
  const iconLinks = [
    {
      relation: 'icon',
      href: productIconDataUrl,
      media: '(prefers-color-scheme: light)',
      variant: 'light',
    },
    {
      relation: 'icon',
      href: productIconInvertedDataUrl,
      media: '(prefers-color-scheme: dark)',
      variant: 'dark',
    },
    {
      relation: 'shortcut icon',
      href: productIconDataUrl,
      media: '',
      variant: 'default',
    },
    {
      relation: 'apple-touch-icon',
      href: productIconDataUrl,
      media: '',
      variant: 'apple-touch',
    },
  ] as const;

  iconLinks.forEach(({ relation, href, media, variant }) => {
    const selector = `link[data-tov-product-icon='${variant}']`;
    const link =
      document.head.querySelector(selector) ?? document.createElement('link');

    link.setAttribute('data-tov-product-icon', variant);
    link.setAttribute('rel', relation);
    link.setAttribute('href', href);
    link.setAttribute('type', productIconMimeType);

    if (media) {
      link.setAttribute('media', media);
    } else {
      link.setAttribute('media', '');
    }

    if (!link.parentNode) {
      document.head.append(link);
    }
  });
}
